module.exports = __webpack_public_path__ + "static/media/lamina23actividad.69e9fb94.png";